const openAllSectionsReducer = (state = false, action) => {
    switch(action.type) {
        case 'CHANGE_OPEN_ALL_SECTIONS_STATUS':
            return !state;
        default:
            return state;
    }
}

export default openAllSectionsReducer;